import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { APIS } from '../../common/constants';
import { Observable } from 'rxjs';
import {OrderProductCategories} from '../../models/orders.model';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  constructor(
    private httpService: HttpService
  ) {
  }

  getOrders(query: Record<string, any>): Observable<any> {
    return this.httpService.getData(APIS.ORDERS.GET_OR_CREATE, query);
  }

  getSkippedOrders(query: Record<string, any>): Observable<any> {
    query['skipped'] = true;
    return this.httpService.getData(APIS.ORDERS.GET_OR_CREATE, query);
  }

  createInspections(data: Record<string, any>): Observable<any> {
    return this.httpService.postData(APIS.ORDERS.GET_OR_CREATE, data);
  }

  updateSkipReason(data: Record<string, any>): Observable<any> {
    return this.httpService.postData(APIS.ORDERS.ADD_SKIP_REASON, {
      ids: data.ids,
      skipReasonId: data.skipReasonId,
    });
  }

  getProductCategories(): Observable<OrderProductCategories[]> {
    return this.httpService.getData(APIS.ORDERS.PRODUCT_CATEGORIES);
  }

}


